import { render, staticRenderFns } from "./CardSustinereSistem.vue?vue&type=template&id=a25fa21a&scoped=true&"
import script from "./CardSustinereSistem.vue?vue&type=script&lang=js&"
export * from "./CardSustinereSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25fa21a",
  null
  
)

export default component.exports